module.exports = __webpack_public_path__ + "img/fb_white_logo.4fb7ba3e.png";